/* eslint-disable */
'use strict';

const EqualHeights = {
    init: function() {
        this.EqualHeights('.js-blog-all__card-title');
        this.EqualHeights('.js-shop-bestsellers__box-desc');
        this.EqualHeights('.js-latest-articles__box-title');
        this.EqualHeights('.js-blog-all__card-tags');
        this.EqualHeights('.product-single__left-testimonial-desc');
    },

    EqualHeights: function(selector) {
        const elements = document.querySelectorAll(selector);
        let maxHeight = 0; // Change const to let

        // Find the maximum height
        elements.forEach(function(element) {
            maxHeight = Math.max(maxHeight, element.getBoundingClientRect().height);
        });

        // Set the height of all elements to the maximum height
        elements.forEach(function(element) {
            element.style.height = maxHeight + 'px';
        });
    }
};

export default EqualHeights;